// extracted by mini-css-extract-plugin
module.exports = {"Shimmer":"Shimmer_Shimmer__3b13i","shimmer":"Shimmer_shimmer__Or2Io"};